module.exports = __webpack_public_path__ + "static/media/service-contract-vendor.e2b29db8.svg";